import { render, staticRenderFns } from "./uploadBook.vue?vue&type=template&id=7d533785&scoped=true&"
import script from "./uploadBook.vue?vue&type=script&lang=js&"
export * from "./uploadBook.vue?vue&type=script&lang=js&"
import style0 from "./uploadBook.vue?vue&type=style&index=0&id=7d533785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d533785",
  null
  
)

export default component.exports